module.exports = __webpack_public_path__ + "img/app_store_download_btn_en.51d02638.svg";